export const createLogoutController = ({ signOut, timeoutMs = 10000, setTimer = setTimeout, clearTimer = clearTimeout }) => {
  let inFlight = null;

  const run = () => {
    if (inFlight) return inFlight;
    let timer;
    const timeout = new Promise((_, reject) => {
      timer = setTimer(() => reject(new Error("Supabase no respondió al cerrar sesión.")), timeoutMs);
    });
    inFlight = Promise.race([Promise.resolve().then(signOut), timeout])
      .then(result => {
        if (result?.error) throw result.error;
        return result;
      })
      .finally(() => {
        if (timer) clearTimer(timer);
        inFlight = null;
      });
    return inFlight;
  };

  return { run, isRunning: () => !!inFlight };
};
